module.exports = __webpack_public_path__ + "media/theme/icon__return-81d59052.svg";